import '../styles/FoundationalTech.css';

const TECH_ITEMS = [
  {
    title: 'Enshrined Data Protocols',
    body: "Flare's protocols are integrated into the blockchain's core, and inherit the economic security of the entire network",
  },
  {
    title: 'Ethereum Virtual Machine',
    body: 'Flare is EVM compatible with out-of-the-box support for all your favorite tooling',
  },
  {
    title: 'Flare Stake',
    body: 'Flare uses a proof-of-stake (PoS) mechanism to ensure a significant and consistent level of economic security',
  },
];

const USE_CASE_CARDS = [
  {
    title: 'FAssets',
    body: 'Securely explore XRPfi, BTCfi and DOGEfi',
    href: 'https://flare.network/products/fassets',
    icon: 'fassets-icon.svg',
  },
];

const PROTOCOL_CARDS = [
  {
    title: 'FDC',
    body: 'Reliably access external blockchain events and real-world APIs',
    href: 'https://flare.network/products/flare-data-connector',
    icon: 'fdc-icon.svg',
  },
  {
    title: 'FTSO',
    body: 'Easily integrate fast, secure, and decentralized price feeds',
    href: 'https://flare.network/products/flare-time-series-oracle',
    icon: 'ftso-icon.svg',
  },
];

function Card({ title, body, href, icon }) {
  return (
    <a href={href} className="tech-card">
      <div className="tech-card__title-row">
        <img
          src={`${process.env.PUBLIC_URL}/images/${icon}`}
          alt=""
          className="tech-card__icon-img"
        />
        <span className="tech-card__title">{title}</span>
        <span className="tech-card__arrow">→</span>
      </div>
      <p className="tech-card__body">{body}</p>
    </a>
  );
}

function FoundationalTech() {
  const iconUrl = `${process.env.PUBLIC_URL}/images/logoo.svg`;
  const videoUrl = `${process.env.PUBLIC_URL}/videos/tech-graphic.webm`;

  return (
    <section className="tech">
      <img src={iconUrl} alt="" className="tech__icon" />

      <div className="tech__row">
        <div className="tech__left">
          <p className="tech__label">Foundational Technology</p>
          {TECH_ITEMS.map((item) => (
            <div className="tech__item" key={item.title}>
              <h3 className="tech__item-title">{item.title}</h3>
              <p className="tech__item-body">{item.body}</p>
            </div>
          ))}
        </div>

        <div className="tech__video-wrap">
          <video
            className="tech__video"
            autoPlay
            muted
            loop
            playsInline
            src={videoUrl}
          />
        </div>

        <div className="tech__right">
          <p className="tech__label">New Use Cases</p>
          {USE_CASE_CARDS.map((card) => (
            <Card key={card.title} {...card} />
          ))}

          <p className="tech__label tech__label--spaced">Enshrined Data Protocols</p>
          {PROTOCOL_CARDS.map((card) => (
            <Card key={card.title} {...card} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FoundationalTech;